<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>

            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">公司名称</div>
                        <el-input v-model="editForm.name"></el-input>
                    </el-col>
                  <el-col :span="12" class="item">
                    <div class="label">地址</div>
                    <el-input v-model="editForm.address"></el-input>
                  </el-col>
                </el-row>

              <el-row class="row">
                <el-col :span="12" class="item">
                  <div class="label">联系人</div>
                  <el-input v-model="editForm.contacts"></el-input>
                </el-col>
                <el-col :span="12" class="item">
                  <div class="label">状态</div>
                    <el-select v-model="editForm.status" style="width:100%;">
                      <el-option
                          v-for="item in status_arr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                </el-col>
              </el-row>

              <el-row class="row">
                <el-col :span="12" class="item">
                  <div class="label">经纬度</div>
                    <el-input v-model="lonlatstr" disabled placeholder="请抓取经纬度">
                      <el-button slot="append" @click="openBaiduMap">抓取</el-button>
                    </el-input>
                </el-col>
              </el-row>

            </div>

            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>

        </div>

        <BaiduMap ref="baiduMap" v-show="baiduMapShow"
                  v-on:colseMap="baiduMapShow = false"
                  v-on:setMap="setMap"></BaiduMap>


    </div>
</template>

<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import BaiduMap from "./BaiduMap";

    export default {
        name: 'Edit',
        props:['roleValue'],
        data() {
            return {

                loading: false,
                baiduMapShow:false,

                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    address:'',
                  contacts: '',
                  status:'',
                  governmentCode:'',

                  lon:'',
                  lat:'',

                },

              status_arr: [{
                  value: 1,
                  label: '正常'
                }, {
                  value: 2,
                  label: '被禁用'
                }],

              lonlatstr:'',

            }
        },
        components: {
            BaiduMap
        },

        methods: {
            init(row){

                this.editForm.name = row.name;
                this.editForm.address = row.address;
                this.editForm.governmentCode = row.governmentCode;
                this.editForm.contacts = row.contacts;
                this.editForm.status = row.status;

              this.editForm.lon = row.lon;
              this.editForm.lat = row.lat;
              this.lonlatstr = row.lon+','+row.lat;

            },

            closeSelf() {
                this.$emit("closeEdit");
            },

          changeStatus:function (selVal) {
            this.editForm.status = selVal;
          },

          openBaiduMap() {
            let gcLonLat = this.bd_encrypta(this.editForm.lon,this.editForm.lat);
            this.$refs.baiduMap.init2(gcLonLat[0],gcLonLat[1]);
            this.baiduMapShow = true;
          },
          closeMap() {
            this.baiduMapShow = false
          },
          setMap(info) {
            this.baiduMapShow = false

            let gcLonLat = this.bMapTransWXMap(info.lng,info.lat);
            this.editForm.lon = gcLonLat[0];
            this.editForm.lat = gcLonLat[1];

            this.lonlatstr = info.lng +","+info.lat;

          },




            confirm(){

              if(this.editForm.name == ''){
                this.$message.info("填写名称");
                return;
              }

              if(this.loading){
                return;
              }else{
                this.loading = true;
              }


              this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

              this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Government/EditByAdmin",
                    data: this.editForm
                }).then((response) => {
                        //console.log(JSON.stringify(response.data));
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else {
                            this.$message({type: 'info', message: '编辑失败'});
                        }
                    }
                )

            },


          // GCJ-02 to BD-09
          bd_encrypta(gg_lon, gg_lat) {
            var X_PI = Math.PI * 3000.0 / 180.0;
            var x = gg_lon, y = gg_lat;
            var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
            var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
            var bd_lon = z * Math.cos(theta) + 0.0065;
            var bd_lat = z * Math.sin(theta) + 0.006;
            return [bd_lon, bd_lat]
          },

          // BD-09 to GCJ-02
          bMapTransWXMap(lng, lat) {
            let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
            let x = lng - 0.0065;
            let y = lat - 0.006;
            let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
            let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
            let lngs = z * Math.cos(theta);
            let lats = z * Math.sin(theta);
            return [lngs, lats]
          },


        }
    }


</script>


<style lang="scss" scoped>


</style>
